import {HuePicker} from 'react-color';

import BaseComponent from "../../../baseComponent.js";
import AppConfig from "../../../../config/config.js"
import styles from "./styles.scss";

export default class CustomColor extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      color: this.props.color
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({color: nextProps.color});
  }

  handleClick(event) {
    let index = $(this.refs.container.children).index(event.currentTarget);
    this.props.onLegendChange("legendColor", AppConfig.DEFAULT_LEGEND_COLORS[index]);
  }

  handleChange(event) {
    const value = event.target.value;
    const isValid = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(value);
    if (isValid) {
      this.props.onLegendChange("legendColor", value);
    }
    this.setState({color: value});
  }

  render() {
    return (
      <div className={styles.configLineWrapper} style={{marginTop: "-20px"}}>
        <div className={styles.configLine}>
          <div className={styles.configLabel}/>
          <div className={styles.colors} ref="container">
            <HuePicker color={this.props.color} onChange={color => this.props.onLegendChange('legendColor', color.hex)}
                       width="275px"/>
            <input type="text" value={this.state.color} onChange={this.handleChange} spellCheck="false"/>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/add-widget/legend-config/customColor.jsx